
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ShIconModule } from '../../../elements/components/icon/icon.module';
import { ProcessingProgress } from '../../entities/processing-progress.entity';
import { ProcessingStatus } from '../../entities/processing-step.entity';

@Component({
    selector: 'sh-processing-progress',
    templateUrl: './processing-progress.component.html',
    styleUrls: ['./processing-progress.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [TranslateModule, ShIconModule],
    providers: [],
    standalone: true
})
export class ProcessingProgressComponent {
    readonly processingStatus: typeof ProcessingStatus = ProcessingStatus;
    @Input() processingProgress: ProcessingProgress;
}
